import axios from "axios";
import { env } from "../../env";
import { RPC_AUTH_ENDPOINTS } from "../endpoints";
import { clearAuthData, getRpcToken } from "../apiService";
import { isTokenExpired } from "../../utils/token";

const BASE_URL = env.REACT_APP_CLIENT_API_URL || "";
const RPC_LOGIN_PATHS = [RPC_AUTH_ENDPOINTS.LOGIN];

const postgreApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

const isRpcAuthRoute = (url = "") => RPC_LOGIN_PATHS.some((path) => url.endsWith(path));

postgreApi.interceptors.request.use(
    (config) => {
        if (isRpcAuthRoute(config?.url)) {
            return config;
        }

        const token = getRpcToken();
        if (!token) {
            clearAuthData();
            window.location.href = "/login";
            return Promise.reject(new Error("Missing RPC token. Please sign in again."));
        }

        if (isTokenExpired(token, { expireOnError: true })) {
            clearAuthData();
            window.location.href = "/login";
            return Promise.reject(new Error("RPC session expired. Please sign in again."));
        }

        config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    (error) => Promise.reject(error)
);

postgreApi.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            clearAuthData();
            window.location.href = "/login";
        }
        return Promise.reject(error);
    }
);

const postgreApiService = {
    get: (url, config = {}) => postgreApi.get(url, config),
    post: (url, data, config = {}) => postgreApi.post(url, data, config),
    put: (url, data, config = {}) => postgreApi.put(url, data, config),
    delete: (url, config = {}) => postgreApi.delete(url, config),
};

export default postgreApiService;
